import React, { useState } from "react";
import PropTypes from "prop-types";
import "../../styles/TimelineItem.css";
import { useDispatch } from "react-redux";
import { fetchAttecment } from "../../redux/actions/grievanceActions1";

// We'll create new styles for this - add this to TimelineItem.css
/*

*/

const TimeLineItem2 = ({
  action,
  date,
  comments,
  attachments,
  onPreviewAttachment,
  onLoadingStateChange,
  isFirst = false,
  isLast = false,
  status_name,
  user_name,
  role_name,
  isIdCard = false,
  eventID,
  type,
  isLoading = false,
  loadingAttachmentId = null,
}) => {
  console.log(attachments, "attachments");
  const dispatch = useDispatch();
  console.log(date);

  const getStatusColor = (status) => {
    const statusLower = status.toLowerCase();

    if (statusLower.includes("raised") || statusLower.includes("submitted")) {
      return "#3498db"; // Blue
    } else if (
      statusLower.includes("rejected") ||
      statusLower.includes("cancelled")
    ) {
      return "#e74c3c"; // Red
    } else if (
      statusLower.includes("closed") ||
      statusLower.includes("completed") ||
      statusLower.includes("feedback")
    ) {
      return "#2ecc71"; // Green
    } else if (statusLower.includes("progress")) {
      return "#f39c12"; // Orange
    } else if (
      statusLower.includes("forwarded") ||
      statusLower.includes("accepted")
    ) {
      return "#9b59b6"; // Purple
    } else {
      return "#95a5a6"; // Gray
    }
  };

  // Get appropriate icon based on status
  const getActionIcon = (status) => {
    const statusLower = status.toLowerCase();

    if (statusLower.includes("submitted") || statusLower.includes("raised")) {
      return "bi-file-earmark-plus";
    } else if (statusLower.includes("rejected")) {
      return "bi-x-circle";
    } else if (
      statusLower.includes("closed") ||
      statusLower.includes("completed") ||
      statusLower.includes("feedback")
    ) {
      return "bi-check-circle";
    } else if (
      statusLower.includes("forwarded") ||
      statusLower.includes("accepted")
    ) {
      return "bi-arrow-right-circle";
    } else if (statusLower.includes("progress")) {
      return "bi-hourglass-split";
    } else {
      return "bi-circle";
    }
  };

  // Get file icon based on extension
  const getFileIcon = (fileName) => {
    const extension = fileName.toLowerCase().split(".").pop();

    switch (extension) {
      case "pdf":
        return "bi-file-earmark-pdf";
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return "bi-file-earmark-image";
      case "doc":
      case "docx":
        return "bi-file-earmark-word";
      case "xls":
      case "xlsx":
        return "bi-file-earmark-excel";
      case "ppt":
      case "pptx":
        return "bi-file-earmark-ppt";
      case "zip":
      case "rar":
        return "bi-file-earmark-zip";
      default:
        return "bi-file-earmark-text";
    }
  };

  // Function to handle eye icon click and make API call
  const handlePreviewClick = async (attachmentId, fileName) => {
    // Notify parent component about loading state change
    onPreviewAttachment(true);
    try {
      const res = await dispatch(fetchAttecment(attachmentId, type));
      console.log(res);
      const attachmentData = res[0]?.ATTACHMENT;
      console.log(attachmentData);
      onPreviewAttachment(false,attachmentData, fileName ,);
    } catch (error) {
      console.error('Error fetching attachment:', error);
      // You can add error handling here if needed
    } finally {
      // Notify parent component that loading is complete
      // if (onLoadingStateChange) {
      //   onLoadingStateChange(false, null);
      // }
    }
  };

  // Check if attachments exists and has items
  const hasAttachments =
    attachments && Array.isArray(attachments) && attachments.length > 0;

  const statusColor = status_name ? getStatusColor(status_name) : "#95a5a6";
  const actionIcon = status_name ? getActionIcon(status_name) : "bi-circle";

  return (
    <div className="modern-timeline-item">
      <div className="timeline-connector">
        <div
          className={`timeline-line ${isFirst ? "first" : ""} ${
            isLast ? "last" : ""
          }`}
          style={{
            background: `linear-gradient(to bottom, ${
              isFirst ? "transparent" : "#e0e0e0"
            }, ${isLast ? "transparent" : "#e0e0e0"})`,
          }}
        ></div>
        <div className="timeline-dot" style={{ backgroundColor: statusColor }}>
          <i className={`bi ${actionIcon}`}></i>
        </div>
      </div>

      <div className="timeline-card">
        <div className="timeline-card-header">
          <div className="status-info">
            <span
              className="status-badge"
              style={{ backgroundColor: statusColor }}
            >
              {status_name || action}
            </span>
            <h4 className="timeline-action">{action}</h4>
          </div>

          <div className="timeline-meta">
            <div className="date-info">
              <i className="bi bi-calendar"></i>
              <span>{date}</span>
            </div>
            <div className="user-info">
              <i className="bi bi-person"></i>
              <span>
                <small>{user_name}</small>
              </span>
            </div>
          </div>
        </div>

        <div className="timeline-card-body">
          {comments && comments !== action && (
            <div className="comments-section">
              <p>{comments}</p>
            </div>
          )}

          {hasAttachments && (
            <div className="attachments-section">
              <h5>
                <i className="bi bi-paperclip"></i>
                Attachments ({attachments.length})
              </h5>

              {/* Global Loading Indicator */}
              {isLoading && (
                <div className="loading-overlay">
                  <div className="loading-spinner">
                    <div className="spinner"></div>
                    <span>Loading attachment...</span>
                  </div>
                </div>
              )}

              <div className="attachments-grid">
                {attachments.map((attachment, index) => {
                  const fileName =
                    attachment.att_name.split(".")[0] || attachment.att_name;
                  const fileType = attachment.att_type || "";
                  const fullFileName =
                    fileName + (fileType ? "." + fileType : "");
                  
                  const currentAttachmentId = attachment.grant_att_id || 
                    attachment.grv_att_id || 
                    attachment.idcard_att_id;
                  
                  const isCurrentLoading = loadingAttachmentId === currentAttachmentId;

                  return (
                    <div className="attachment-card" key={index}>
                      <div className="attachment-icon">
                        <i className={`bi ${getFileIcon(fileType)}`}></i>
                      </div>
                      <div className="attachment-details">
                        <span className="attachment-name">{fileName}</span>
                      </div>
                      <div className="attachment-actions">
                        <button
                          className={`preview-btn ${isCurrentLoading ? 'loading' : ''}`}
                          title="Preview file"
                          disabled={isLoading}
                          onClick={() =>
                            handlePreviewClick(
                              currentAttachmentId,
                              attachment.att_name
                            )
                          }
                        >
                          {isCurrentLoading ? (
                            <div className="button-spinner"></div>
                          ) : (
                            <i className="bi bi-eye"></i>
                          )}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

TimeLineItem2.propTypes = {
  action: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  comments: PropTypes.string,
  attachments: PropTypes.array,
  onPreviewAttachment: PropTypes.func,
  onLoadingStateChange: PropTypes.func,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  status_name: PropTypes.string,
  user_name: PropTypes.string,
  role_name: PropTypes.string,
  isIdCard: PropTypes.bool,
  eventID: PropTypes.string,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  loadingAttachmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TimeLineItem2;